import buildHeaders from './fetchHeaders';
import {API_BASE} from './reports';

/**
 * Start an async reference import job on the backend.
 *
 * @param {string} reportId
 * @param {Array<{number: number, url: string, statementText: string, paragraphIndex: number, charOffset: number}>} references
 * @returns {Promise<void>}
 */
export async function startReferenceImport(reportId, references) {
    const response = await fetch(`${API_BASE}/reports/import-references`, {
        method: 'POST',
        headers: buildHeaders({'Content-Type': 'application/json'}),
        body: JSON.stringify({reportId, references}),
    });

    if (!response.ok) {
        let message = 'Failed to start reference import';
        try {
            const text = await response.text();
            if (text) message += `: ${text}`;
        } catch (_) {
        }
        throw new Error(message);
    }
}

/**
 * Poll the backend for the current reference import status.
 *
 * @param {string} reportId
 * @returns {Promise<{status: string, references: Array, error: string|null}>}
 *   status: "processing" | "done" | "failed" | "not_found"
 */
export async function checkReferenceImportStatus(reportId) {
    const response = await fetch(
        `${API_BASE}/reports/${encodeURIComponent(reportId)}/import-references/status`,
        {headers: buildHeaders({})},
    );

    if (!response.ok) {
        throw new Error(`Failed to check reference import status: ${response.status}`);
    }

    return await response.json();
}
